import React, { useState, useEffect } from "react";
import SaveButton from "../Components/AdminButtons";
import SideBar from "../Components/SideBar";
import MediaPicker from "../Components/mediaPicker";
import { setLoading } from "../../Redux/action";
import apiRequest from "../../apiCall";
import config from "../Config.json";

import { useDispatch } from "react-redux";
import { Toaster, toast } from "react-hot-toast";

export default function AdminContactUs() {
  const [data, setData] = useState({
    description: '',
    address: '',
    email: '',
    phone: '',
    whatsapp: '',
  });
  const _data = data;

  const dispatch = useDispatch();
  const handleSave = async () => {
    dispatch(setLoading(true));
    if (
      data.description &&
      data.address &&
      data.email &&
      data.phone &&
      data.whatsapp
    ) {
      saveData();
    } else {
      dispatch(setLoading(false));
      toast.error( "Please fill all values" );
    }
  };
  
  const saveData = () => {
    const params = {
      description: data.description,
      address: data.address,
      email: data.email,
      phone: data.phone,
      whatsapp: data.whatsapp,
    };
    apiRequest("POST", "contactus", params, false, false)
      .then((res) => {
        if (res) {
          dispatch(setLoading(false));
          toast.success( "Data saved successfully" );
        } else {
          dispatch(setLoading(false));
          toast.error( "Something went wrong" );
        }
      })
      .catch((error) => {
        console.error("Error saving data:", error);
        dispatch(setLoading(false));
        toast.error("Failed to save data" );
      });
  };
  
  const updateData = () => {
    setData(data => ({
      ...data,
      ..._data,
    }));
  };


  const getApiData = async () => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      apiRequest('GET', 'contactus', null, false, false).then(res => {
        dispatch(setLoading(false));
        sessionStorage.setItem('contactusApi', JSON.stringify(res));
        resolve(res);
       
        _data.description = res.description;
        _data.address = res.address;
        _data.email = res.email;
        _data.phone = res.phone;
        _data.whatsapp = res.whatsapp;
        updateData();
      })
        .catch(error => {
          dispatch(setLoading(false));
          console.error('Error calling home API:', error);
          reject(error);
        });
    });


  }

  useEffect(() => {
    getApiData();
  }, [])

  return (
    <div className="admin-contact-us">
      <SideBar />
      <div className="admin-container">
        <h1>Contact Us</h1>
        <br />
        <div className="sec">
          <div className="input-field">
            <textarea
              id="description"
              className="materialize-textarea"
              style={{ height: 100, width: "100%", resize: "none" }}
              value={data.description}
              onChange={(descriptions) => {
                descriptions = descriptions.currentTarget.value;
                _data.description = descriptions;
                updateData();
              }}
            />
            <label htmlFor="description">Description</label>
          </div>
        </div>
        <br />
        <div className="sec">
          <div className="input-field">
            <textarea
              id="address"
              className="materialize-textarea"
              style={{ height: 150, width: "100%", resize: "none" }}
              value={data.address}
              onChange={(addresss) => {
                addresss = addresss.currentTarget.value;
                _data.address = addresss;
                updateData();
              }}
            />
            <label htmlFor="address">Address</label>
          </div>
          <div className="input-field">
            <input
              id="phone"
              type="text"
              className="validate"
              value={data.phone}
              onChange={(phones) => {
                phones = phones.currentTarget.value;
                _data.phone = phones;
                updateData();
              }}
            />
            <br />
            <label htmlFor="phone">Phone</label>
          </div>
          <div className="input-field">
            <input
              id="whatsapp"
              type="text"
              className="validate"
              value={data.whatsapp}
              onChange={(whatsapps) => {
                whatsapps = whatsapps.currentTarget.value;
                _data.whatsapp = whatsapps;
                updateData();
              }}
            />
            <br />
            <label htmlFor="phone">Whatsapp</label>
          </div>
          <div className="input-field">
            <input
              id="email"
              type="text"
              className="validate"
              value={data.email}
              onChange={(emails) => {
                emails = emails.currentTarget.value;
                _data.email = emails;
                updateData();
              }}
            />
            <br />
            <label htmlFor="email">Email</label>
          </div>
        </div>
        <br />
        <SaveButton onClick={handleSave} />
        <Toaster position="top right" />
      </div>
    </div>
  );
}
